import { FC } from 'react';
import NewClaimComponent from 'components/NewClaim/NewClaim.component';

const NewClaim: FC = () => {
	return <NewClaimComponent />;
};

export default NewClaim;
